import React, {Component} from 'react';
import {SimpleInput, Quantity} from 'components/UI/Form/Fields'

import AdvanceSettings from './AdvanceSettings'
import moment from 'moment'

import './TicketList.scss'

class RegistrationSetting extends Component{

  constructor(props){
    super(props)

    const {title, amount, startDate, startTime, endDate, endTime, price, noEndTime, auto_wait_list, index, ticketLength} = props.ticket

    this.state = {
      showingAdvance: true,
      data: {
        ...props.ticket,
        title: title || '',
        amount: amount || '',
        startDate: startDate ? startDate : moment().format('YYYY-MM-DD'),
        startTime: startTime ? startTime : moment().format('00:00:00'),
        endDate: endDate || moment().format('YYYY-MM-DD'),
        endTime: endTime || '00:00:00',
        price: price || 0,
        noEndTime: noEndTime || true,
        auto_wait_list: auto_wait_list == 1 ? 'enterWaitList' : 'noWaitList' || 'enterWaitList',
        index: index,
      }

    }

    this.onChange = this.onChange.bind(this)
    this.showingAdvanceCallback = this.showingAdvanceCallback.bind(this)
  }


  onChange(name) {
    const {onTicketChange} = this.props

    return (value) => {
      let newValue;

      if(name == 'startDate' || name == 'endDate'){
        if (value instanceof moment) {
          newValue = value.format('YYYY-MM-DD');
        }
      } else if (name == 'startTime' || name == 'endTime'){
        if (value instanceof moment) {
          newValue = value.format('HH:mm:ss');
        }
      } else if (name == 'noEndTime'){
        newValue = value.target.checked
      } else if (name == 'auto_wait_list') {
        newValue = value.target.value
      } else if (name == 'price'){
        if(value == ''){
          newValue = '0'
        } else {
          newValue = value.replace('$', '')
        }
      } else {
        newValue = value
      }

      this.setState({
        data: {
          ...this.state.data,
          [name]: newValue,
         }
      }, () => {
        onTicketChange(this.state.data)
      })
    }
  }

  showingAdvanceCallback(data){
    this.setState(data)
  }

  render(){
    let {showingAdvance, data} = this.state;
    let {title, price, amount} = data
    const {onTicketChange, ticket, onRemoveTicket, type} = this.props

    return(
      <div className='registration-setting-content'>
        <div className='row btn-row'>
          <div className='col-xs-4'>
            <SimpleInput value={title} onChange={this.onChange('title')} placeholder={__('Dance Class, English Class, etc', 'ticket')} />
          </div>
          <div className='col-xs-3'>
            <Quantity value={amount} onChange={this.onChange('amount')} suffix={__('', 'ticket')} />
          </div>
          <div className='col-xs-3 price-description'>
            { type == 'freeOrPayOffline' ? __('Pay Offline', 'ticket') : __('Pay Online', 'ticket')}
          </div>
          <div className='col-xs-2 registration-setting-icon'>
            <i className='fa icon-cog registration-setting-cog' onClick={() => {
              if(showingAdvance == false){
                this.setState({showingAdvance: true})
              }else{
                this.setState({showingAdvance: false})
              }
            }}></i>
            <i className='fa icon-trash registration-setting-trash' onClick={onRemoveTicket}></i>
          </div>
        </div>
        {showingAdvance == true && <AdvanceSettings type={type} data={data} onChange={this.onChange} callbackFromParent={this.showingAdvanceCallback} />}
      </div>
    )
  }
}


export default RegistrationSetting



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/EditPoster/Register/RegistrationSetting.js